import { QuinnCopy, QuinnScopeMode, type QuinnScope } from "../types";

export const SELECT_CLIENT_LABEL = QuinnCopy.SelectClient;
export const ALL_CLIENTS_LABEL = QuinnCopy.AllClients;
export const NO_CLIENT_LABEL = QuinnCopy.NoClient;

export const DEFAULT_SCOPE: QuinnScope = {
    mode: QuinnScopeMode.Client,
    businessId: null,
    businessLabel: SELECT_CLIENT_LABEL,
};

export const ALL_CLIENTS_SCOPE: QuinnScope = {
    mode: QuinnScopeMode.AllClients,
    businessId: null,
    businessLabel: ALL_CLIENTS_LABEL,
};

export function scopeIsAnswerable(scope: QuinnScope): boolean {
    return scope.mode === QuinnScopeMode.AllClients || Boolean(scope.businessId);
}

export const QUINN_FULLSCREEN_PATH = "/quinn";

export function quinnFullscreenPath(chatId: string | null): string {
    return chatId ? `${QUINN_FULLSCREEN_PATH}/${chatId}` : QUINN_FULLSCREEN_PATH;
}

export function isQuinnFullscreenPath(pathname: string): boolean {
    return pathname === QUINN_FULLSCREEN_PATH || pathname.startsWith(`${QUINN_FULLSCREEN_PATH}/`);
}
